import React, { useState } from 'react';
import { Link } from 'react-router-dom';

import axiosRestaurantInstance from '../restaurant/AxiosRestaurantInstance';
import { extractRestaurantId, extractRestaurantName } from '../restaurant/restaurantApi';
import EatsAppPageShell from './EatsAppPageShell';
import { useAutoDismissMessage } from '../utils/useAutoDismissMessage';

const inputStyle = {
  width: '100%',
  padding: '8px 10px',
  border: '1px solid #ccc',
  borderRadius: 6,
  boxSizing: 'border-box',
};

const EatsAppRestaurantsPage = () => {
  const [search, setSearch] = useState('');
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  useAutoDismissMessage(error, setError);

  const authHeaders = () => {
    const token = localStorage.getItem('Token');
    return token ? { Authorization: `Bearer ${token}` } : {};
  };

  const searchRestaurants = async () => {
    const query = search.trim();
    if (!query) {
      setError('Enter a restaurant name, city, or id to search.');
      return;
    }

    setLoading(true);
    setError('');
    try {
      const res = await axiosRestaurantInstance.get('/restaurant/search', {
        params: { search: query },
        headers: authHeaders(),
      });
      const rows = Array.isArray(res.data) ? res.data : res.data?.restaurants || [];
      setResults(rows);
    } catch (e) {
      console.error('Restaurant search failed:', e);
      setError(
        e?.response?.data?.message ||
          e?.response?.data?.error ||
          'Failed to search restaurants.'
      );
      setResults([]);
    } finally {
      setLoading(false);
    }
  };

  return (
    <EatsAppPageShell>
      <h2 style={{ marginTop: 0 }}>Restaurants</h2>
      <p style={{ color: '#555', marginBottom: 16 }}>
        Search restaurants to manage enabled services.
      </p>

      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, marginBottom: 16, alignItems: 'center' }}>
        <input
          style={{ ...inputStyle, width: 280, maxWidth: '100%' }}
          placeholder="Search by restaurant name, city, or id"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') searchRestaurants();
          }}
        />
        <button type="button" onClick={searchRestaurants} disabled={loading} style={{ padding: '8px 12px' }}>
          {loading ? 'Searching…' : 'Search'}
        </button>
      </div>

      {error ? <div style={{ color: '#a40000', marginBottom: 12 }}>{error}</div> : null}

      <div style={{ border: '1px solid #eee', borderRadius: 8, overflow: 'hidden' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr>
              <th style={{ textAlign: 'left', padding: 8 }}>ID</th>
              <th style={{ textAlign: 'left', padding: 8 }}>Name</th>
              <th style={{ textAlign: 'left', padding: 8 }}>Status</th>
              <th style={{ textAlign: 'left', padding: 8 }}>Services</th>
            </tr>
          </thead>
          <tbody>
            {results.length === 0 ? (
              <tr>
                <td colSpan={4} style={{ padding: 8, color: '#666' }}>
                  {loading ? 'Searching…' : 'No results yet.'}
                </td>
              </tr>
            ) : (
              results.map((row, index) => {
                const id = extractRestaurantId(row);
                const name = extractRestaurantName(row) || '—';
                return (
                  <tr key={id || index}>
                    <td style={{ padding: 8 }}>{id || '—'}</td>
                    <td style={{ padding: 8 }}>{name}</td>
                    <td style={{ padding: 8 }}>{row.status || '—'}</td>
                    <td style={{ padding: 8 }}>
                      {id ? (
                        <Link
                          to={`/eats/admin/restaurants/${id}`}
                          style={{ color: '#1e4f7a', fontWeight: 600 }}
                        >
                          Manage
                        </Link>
                      ) : (
                        '—'
                      )}
                    </td>
                  </tr>
                );
              })
            )}
          </tbody>
        </table>
      </div>
    </EatsAppPageShell>
  );
};

export default EatsAppRestaurantsPage;
